module.exports = __webpack_public_path__ + "static/media/poop.f95c8bd8.svg";